<p-sidebar [visible]="isVisibleFilters()" position="right" [modal]="false" [showCloseIcon]="false" [transitionOptions]="'200ms'">
  <div class="filter_content">
    <div class="flex flex-between" style="align-items: unset!important; flex-direction: row; width: 100%; padding: 16px 16px 12px 16px; border-bottom: 1px solid #E5E5E5">
      <div class="filter_name" style="margin-right: auto;">
        Фільтр
      </div>
      <div style="margin-left: auto" class="flex-between flex">
        <div style="margin-right: 16px"><med-icon-history [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" (click)="filter.resetFilter('/reserves')"></med-icon-history></div>
        <div><med-icon-close [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" (click)="this.filter.showReservesFilter = false"></med-icon-close></div>
      </div>
    </div>
    <div style="width: 100%; padding-left: 16px; padding-right: 25px">
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="LOV ID"
          label="LOV ID"
          [(ngModel)]="filter.reserves.lovId[0]"
          (ngModelChange)="filter.onLovIdChange($event)"
          (focusout)="filter.reservesStateChanged()"
          [disabled]="showGoodsSpecifications"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="МНН ID"
          label="МНН ID"
          [(ngModel)]="filter.reserves.mnnId[0]"
          (ngModelChange)="filter.onMnnIdChange($event)"
          (focusout)="filter.reservesStateChanged()"
          [disabled]="showGoodsSpecifications"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-multi-select
          size="small"
          [hideClearBtn]="true"
          placeholder="{{ !filter.reserves.direction.length ? 'Всі': 'Обрано фільтрів: ' + filter.reserves.direction.length }}"
          label="Напрям"
          [options]="filter.suppliesOptions.directions"
          [(ngModel)]="filter.reserves.direction"
          (ngModelChange)="filter.reservesStateChanged()"
        ></med-multi-select>
      </div>
      <div style="width: 100%;">
        <med-multi-select
          size="small"
          [hideClearBtn]="true"
          placeholder="{{ !filter.reserves.mnn.length ? 'Всі': 'Обрано фільтрів: ' + filter.reserves.mnn.length }}"
          label="МНН"
          [options]="filter.suppliesOptions.mnns"
          [(ngModel)]="filter.reserves.mnn"
          (ngModelChange)="filter.reservesStateChanged()"
        ></med-multi-select>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Дозування"
          label="Дозування"
          [(ngModel)]="filter.reserves.dosage[0]"
          (focusout)="filter.reservesStateChanged()"
          [disabled]="showGoodsSpecifications"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Одиниця виміру"
          label="Одиниця виміру"
          [(ngModel)]="filter.reserves.measure[0]"
          (focusout)="filter.reservesStateChanged()"
          [disabled]="showGoodsSpecifications"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Відмова"
          label="Відмова"
          [(ngModel)]="filter.reserves.reject[0]"
          (focusout)="filter.reservesStateChanged()"
          [disabled]="showGoodsSpecifications || true"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Доступно для розподілу"
          label="Доступно для розподілу"
          [(ngModel)]="filter.reserves.availability[0]"
          (ngModelChange)="filter.onAvailabilityIdChange($event)"
          (focusout)="filter.reservesStateChanged()"
          [disabled]="showGoodsSpecifications"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Наказ/Відмова"
          label="Наказ/Відмова"
          [(ngModel)]="filter.reserves.documents[0]"
          (focusout)="filter.reservesStateChanged()"
          [disabled]="showGoodsSpecifications || true"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-input
          size="small"
          [hideClearBtn]="true"
          placeholder="Піднапрям"
          label="Піднапрям"
          [(ngModel)]="filter.reserves.subDirection[0]"
          (focusout)="filter.reservesStateChanged()"
          [disabled]="showGoodsSpecifications"
        ></med-input>
      </div>
      <div style="width: 100%;">
        <med-datepicker
          [disabled]="true"
          size="small"
          [mode]="'range'"
          label="Контрольна дата"
          placeholder="Оберіть дату"
          [(ngModel)]="filter.reserves.controlDate"
          (onInput)="filter.reservesStateChanged()"
        ></med-datepicker>
      </div>

    </div>
  </div>
</p-sidebar>

<div class="flex flex-center flex-between">
    <app-page-title></app-page-title>
    <div class="flex flex-center flex-between" style="margin-top: 16px">
        <med-switch label="Показати товари" [(ngModel)]="showGoodsSpecifications" (ngModelChange)="viewChanged()"></med-switch>&nbsp;&nbsp;
        <med-tab-group
                [options]="optionsTabGroup"
                [(value)]="optionsModel"
                (valueChange)="tabGroupChanged()">
            <ng-template medTemplate="tab" let-option>
                {{option.label}}
            </ng-template>
        </med-tab-group>
    </div>
</div>

<app-loader [hidden]="loadingCounter === 0"></app-loader>

<div class="table-wrapper" *ngIf="!showGoodsSpecifications" [hidden]="loadingCounter > 0">
    <p-table
        #dt
        styleClass="p-datatable-sm"
        [scrollable]="true"
        scrollHeight="flex"
        [value]="tableBodyReserveGoods"
        [customSort]="true"
        [lazy]="true"
        [resizableColumns]="true"
        columnResizeMode="expand"
        [columns]="tabHeaderReserveGoods"
        [reorderableColumns]="true"
        (onLazyLoad)="loadData()"
        (onColReorder)="saveColumnOrder()">

        <ng-template pTemplate="header">
            <tr>
              <th><!-- checkbox row--></th>
                <th class="table-header-text table-header-bg-grey" [pSortableColumn]="column.key" *ngFor="let column of tabHeaderReserveGoods" style="min-width: 10em" pReorderableColumn pResizableColumn>
                    <div style="display: inline-block" class="flex align-items-center" [ngStyle]="{'max-width': ['8', '11'].includes(column.key) ? '10em': 'initial'}" [ngClass]="{'no-wrap': ['8', '11'].includes(column.key)}">
                        {{ column.label }}&nbsp;
                        <p-sortIcon [field]="column.key" *ngIf="filterActive && filterField === column.key"></p-sortIcon>
                    </div>
                </th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row let-columns="columns">
            <tr class="table-content-text">
                <td>
                    <med-checkbox size="small" *ngIf="'MZU' === dataService.userRoleValue.getValue()"
                                  (change)="onChangeHandlerGood(row)"
                                  [value]="basketService.containsAnySpecificationId(row.specificationIds)"
                                  [disabled]="basketService.hasTheDifferentDirection(row.direction.id) || basketService.hasTheDifferentWarehouse(row.warehouseName)"></med-checkbox>
                </td>
              <ng-container *ngFor="let col of columns">
                <td class="h10-text black-80" *ngIf="col.key === '1'">
                  {{row.lovId}}
                </td>
                <td class="h10-text black-60" *ngIf="col.key === '2'">
                  {{row.mnnId}}
                </td>
                <td class="h10-text black-80" *ngIf="col.key === '3'">
                    <div class="flex-12rem">
                        <span class="truncate-text" [pTooltip]="tooltipDirection">
                            {{row.direction.shortName}}
                        </span>
                    </div>
                  <ng-template #tooltipDirection >
                    <div class="flex items-center h10-text">
                      {{row.direction.name}}
                    </div>
                  </ng-template>
                </td>
                <td class="h10-text black-80" *ngIf="col.key === '4'">
                    <div class="flex-12rem">
                        <span class="truncate-text" [pTooltip]="tooltipMnn">
                          {{row.mnnName}}
                        </span>
                    </div>
                  <ng-template #tooltipMnn >
                    <div class="flex items-center h10-text">
                      {{row.mnnName}}
                    </div>
                  </ng-template>

                </td>
                <td class="h10-text black-60" *ngIf="col.key === '5'">
                  {{row.dosage}}
                </td>
                <td class="h10-text black-60" *ngIf="col.key === '6'">
                  {{row.unit}}
                </td>
                <td class="h10-text black-80" *ngIf="col.key === '7'">
                    <img [src]="getPathStatusImg(row.refusal)" width="4" height="16" style="vertical-align: middle;"/>
                    <span>{{ row.refusal ? ' Так' : ' Ні' }}</span>
                </td>
                <td class="h10-text black-80" *ngIf="col.key === '8'">
                  {{row.availableForDistribution}}
                </td>
                <td *ngIf="col.key === '9'">
                    <a href="JavaScript:alert('Not implemented yet');">
                      {{row.documents}}
                    </a>
                </td>
                <td class="h10-text black-80" *ngIf="col.key === '10'">
                    <div class="flex-12rem">
                        <span class="truncate-text">
                          {{row.subDirection}}
                        </span>
                    </div>
                </td>
                <td class="h10-text black-60" *ngIf="col.key === '11'">
                  <div class="flex align-items-center">
                    <span *ngIf="!isDatEditingAllowed(row.id)">{{row.controlDate | date: 'dd.MM.yyyy'}}</span>
                    <span>
                      <med-datepicker [size]="'small'" *ngIf="isDatEditingAllowed(row.id)" [(ngModel)]="editingGoodsLovControlDateDto.controlDate"></med-datepicker>
                    </span>
                    <med-icon-edit size="14" class="ml-1 cursor-pointer" (click)="allowDateEditing(row)" *ngIf="!isDatEditingAllowed(row.id)"></med-icon-edit>
                    <med-icon-check size="24" class="text-green-100 ml-1 cursor-pointer" [pTooltip]="tooltipSave" *ngIf="isDatEditingAllowed(row.id)" style="margin-bottom: 1rem;" (click)="approveLovIdDataChanging(row)"></med-icon-check>
                    <med-icon-circle-slash size="20" class="text-red-100 ml-1 cursor-pointer" [pTooltip]="tooltipCancel" *ngIf="isDatEditingAllowed(row.id)" style="margin-bottom: 1rem;" (click)="cancelLovIdDataChanging(row)"></med-icon-circle-slash>
                  </div>
                  <ng-template #tooltipSave>
                    <div class="flex items-center h10-text">
                      Зберегти нову дату
                    </div>
                  </ng-template>
                  <ng-template #tooltipCancel>
                    <div class="flex items-center h10-text">
                      Не зберігати зміни
                    </div>
                  </ng-template>
                </td>
              </ng-container>
            </tr>
        </ng-template>

        <ng-template pTemplate="summary">
            <div class="flex flex-center flex-between">
                <med-pagination
                        [total]="totalRowsReserveGoods"
                        [page]="selectedPageNumber"
                        [perPage]="pageSize"
                        (pageChange)="pageChange($event)"
                ></med-pagination>

                <div class="small-text">
                    Показано &nbsp;<strong>{{ getFirstShowedRowIndex() }}</strong>-<strong>{{ getFirstShowedRowIndex() + pageSize }}</strong> &nbsp;з {{ totalRowsReserveGoods }}
                </div>

                <div>
                    <span class="small-text">Кількість на сторінку</span>
                    <med-radio-group
                            mode="buttons"
                            [value]="totalRowsReserveGoods"
                            [options]="paginationOptions"
                            (onInput)="pageSizeChanged($event)"
                    ></med-radio-group>
                </div>
            </div>
        </ng-template>
    </p-table>
</div>
<div class="table-wrapper" *ngIf="showGoodsSpecifications" [hidden]="loadingCounter > 0">
    <p-table

        #dt2
        styleClass="p-datatable-sm"
        [scrollable]="true"
        scrollHeight="flex"
        [value]="tableBodySpecifications"
        [customSort]="true"
        [lazy]="true"
        [resizableColumns]="true"
        columnResizeMode="expand"
        (onLazyLoad)="loadData()">
        <ng-template pTemplate="header">
            <tr>
                <th><!-- checkbox row--></th>
                <th class="table-header-text" [pSortableColumn]="column.key" *ngFor="let column of filterHeader(tabHeaderSpecifications)" style="background-color: rgb(249, 249, 249)!important; min-width: 10em" pResizableColumn>
                    <div style="display: inline-block" class="flex align-items-center" [ngStyle]="{'max-width': ['3', '10', '14', '15', '17', '19', '20', '21'].includes(column.key) ? '15em': 'initial'}" [ngClass]="{'no-wrap': ['3', '10', '14', '15', '17', '19', '20', '21'].includes(column.key)}">
                        {{ column.label }}&nbsp;
                        <p-sortIcon [field]="column.key" *ngIf="filterActive && filterField === column.key"></p-sortIcon>
                        <med-icon-chevron-right [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" *ngIf="'2' === column.key && column.showChevron && !hideGroup1" (click)="showHidedColumns($event, column.key, true)"></med-icon-chevron-right>
                        <med-icon-chevron-left [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" *ngIf="'2' === column.key && column.showChevron && hideGroup1" (click)="showHidedColumns($event, column.key, false)"></med-icon-chevron-left>
                        <med-icon-chevron-right [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" *ngIf="'17' === column.key && column.showChevron && !hideGroup2" (click)="showHidedColumns($event, column.key, true)"></med-icon-chevron-right>
                        <med-icon-chevron-left [ngStyle]="{'width': '16px', 'cursor': 'pointer'}" *ngIf="'17' === column.key && column.showChevron && hideGroup2" (click)="showHidedColumns($event, column.key, false)"></med-icon-chevron-left>
                    </div>
                </th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
            <tr class="table-content-text" (dblclick)="goToDetails('10')">
                <td>
                    <med-checkbox size="small"  *ngIf="'MZU' === dataService.userRoleValue.getValue()"
                                  (change)="onChangeHandlerSpecification(row)"
                                  [value]="basketService.containsAlreadySpecification(row.specificationId)"
                                  [disabled]="basketService.hasTheDifferentDirection(row.good.direction.id) || basketService.hasTheDifferentWarehouse(row.warehouseName)"></med-checkbox>
                </td>
                <td class="h10-text black-80">
                    <div class="flex-12rem">
                        <span class="truncate-text">
                          {{row.good.mnnName}}
                        </span>
                    </div>
                </td>
                <td class="h10-text black-60">
                  {{row.good.dosage}}
                </td>
                <td class="h10-text black-80 grey-20-background" *ngIf="!hideGroup1">
                    {{row.extra.availableForDistribution}}
                </td>
                <td class="h10-text black-80 grey-20-background" *ngIf="!hideGroup1">
                    {{row.good.mnnId}}
                </td>
                <td class="h10-text black-80 grey-20-background" *ngIf="!hideGroup1">
                    {{row.good.lovId}}
                </td>
                <td class="h10-text black-60 grey-20-background" *ngIf="!hideGroup1">
                    <div class="flex-12rem">
                        <span class="truncate-text" [pTooltip]="tooltipDirectionSpec">
                          {{row.good.direction.shortName}}
                        </span>
                    </div>
                  <ng-template #tooltipDirectionSpec >
                    <div class="flex items-center h10-text">
                      {{row.good.direction.name}}
                    </div>
                  </ng-template>

                </td>
                <td class="h10-text black-60 grey-20-background" *ngIf="!hideGroup1">
                    {{row.good.unit}}
                </td>
                <td class="h10-text black-80 grey-20-background" *ngIf="!hideGroup1">
                    {{row.extra.documents}}
                </td>
                <td class="h10-text black-80 grey-20-background" *ngIf="!hideGroup1">
                    {{row.good.subDirection}}
                </td>
                <td>
                    <div class="flex-12rem">
                        <span class="truncate-text">
                          {{row.seriesCatalogue}}
                        </span>
                    </div>
                </td>
                <td class="h10-text black-80">
                    <div class="flex-12rem">
                        <span class="truncate-text">
                          {{row.good.tradeName}}
                        </span>
                    </div>
                </td>
                <td class="h10-text black-80">
                  {{row.multiplicity}}
                </td>
                <td class="h10-text black-80">
                  {{row.quantity}}

                </td>
                <td class="h10-text black-80">
                  {{row.adjUnitPrice}}
                </td>
                <td class="h10-text black-80">
                  {{getRowSum(row.extra.availableForDistribution, row.adjUnitPrice)}}
                </td>
                <td class="h10-text black-80">
                    Номер договору *
                </td>
                <td class="h10-text black-80">
                  {{row.dueDate | date: 'dd.MM.yyyy'}}
                </td>
                <td class="h10-text black-80 grey-20-background" *ngIf="!hideGroup2">
                  {{row.manufacturer}}
                </td>
                <td class="h10-text black-80 grey-20-background" *ngIf="!hideGroup2">
                  {{row.manufacturerCountry}}
                </td>
                <td class="h10-text black-80 grey-20-background" *ngIf="!hideGroup2">
                  {{row.originCountry}}
                </td>
                <td class="h10-text black-80 grey-20-background" *ngIf="!hideGroup2">
                  {{row.manufactureDate | date: 'dd.MM.yyyy'}}
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="summary">
            <div class="flex flex-center flex-between">
                <med-pagination
                        [total]="totalRowsSpecifications"
                        [page]="selectedPageNumberSpecifications"
                        [perPage]="pageSizeSpecifications"
                        (pageChange)="pageChangeSpecifications($event)"
                ></med-pagination>

                <div class="small-text">
                    Показано &nbsp;<strong>{{ getFirstShowedRowIndexSpecifications() }}</strong>-<strong>{{ getFirstShowedRowIndexSpecifications() + pageSizeSpecifications }}</strong> &nbsp;з {{ totalRowsSpecifications }}
                </div>

                <div>
                    <span class="small-text">Кількість на сторінку</span>
                    <med-radio-group
                            mode="buttons"
                            [value]="totalRowsSpecifications"
                            [options]="paginationOptions"
                            (onInput)="pageSizeChangedSpecifications($event)"
                    ></med-radio-group>
                </div>
            </div>
        </ng-template>
    </p-table>
</div>
